<template>
  <div class="lead-content">
    <SPreloader />
    <div
      class="main-header main-header-fullwidth main-header-has-header-standard mb-0"
    >
      <SLandingTopBar />
      <SSubHeader pageName="About us" />
      <div class="header-spacer--standard"></div>
    </div>
    <div class="container">
      <div class="row display-flex">
        <SLandingContent />
      </div>
    </div>
    <HowSwampumWorks />
    <HowSwampumPointsWorks :registerButton="true" />
    <FindPeopleSectionLandingPage />
    <SLandingBottomContent />
    <Footer />
    <a class="back-to-top" href="#" ref="goTop" v-if="isBottom">
      <img src="svg-icons/back-to-top.svg" alt="arrow" class="back-icon" />
    </a>
    <Modal
      buttonName="OK"
      id="facebook-error"
      title="Facebook error"
      @button="closeModal('facebook-error')"
      ref="fbError"
    >
      <h5>
        Something went wrong when trying to validate your Facebook account.
      </h5>
    </Modal>
    <Modal
      id="login-redirect-modal"
      buttonName="Continue to log in"
      ref="modal"
      title="Authentication required"
      @button="confirmRedirect"
      :materialButton="true"
    >
      <h5 class="login-text">Please log in or register to continue</h5>
    </Modal>
    <CookiesAndPrivacy
      v-if="!storageCookies"
      @cookies-privacy="accept"
      :class="[{ 'safari-space': showSafariWarning }]"
    />
    <SafariWarning
      ref="safariWarning"
      @safari-warning="showSafariWarning = false"
    />
  </div>
</template>

<script>
import SPreloader from "@/components/organisms/SPreloader.vue";
import SLandingTopBar from "@/material-components/organisms/SLandingTopBar.vue";
import Footer from "@/templates/Footer";
import Modal from "@/components/atoms/Modal.vue";
import FindPeopleSectionLandingPage from "@/components/molecules/FindPeopleSectionLandingPage";
import CookiesAndPrivacy from "@/components/molecules/CookiesAndPrivacy";
import SLandingBottomContent from "@/material-components/molecules/SLandingBottomContent.vue";
import SLandingContent from "@/material-components/molecules/SLandingContent.vue";
import HowSwampumWorks from "@/material-components/molecules/HowSwampumWorks.vue";
import HowSwampumPointsWorks from "@/material-components/molecules/HowSwampumPointsWorks.vue";
import SSubHeader from "@/material-components/organisms/SSubHeader.vue";
import ItemHelper from "@/mixins/ItemHelper";
import { mapGetters } from "vuex";
import SafariWarning from "@/material-components/molecules/SafariWarning.vue";

export default {
  name: "AboutUs",
  mixins: [ItemHelper],
  components: {
    SPreloader,
    SLandingTopBar,
    SLandingContent,
    FindPeopleSectionLandingPage,
    Footer,
    Modal,
    CookiesAndPrivacy,
    SLandingBottomContent,
    HowSwampumWorks,
    HowSwampumPointsWorks,
    SafariWarning,
    SSubHeader,
  },
  data() {
    return {
      cookiesPrivacy: localStorage.getItem("cookies_privacy"),
      ip: null,
      isBottom: false,
      landingPageItems: [],
      redirectTo: null,
      canRedirect: false,
      showSafariWarning: false,
      prevRoute: null,
    };
  },
  computed: {
    ...mapGetters({
      isUserAuthenticated: "isUserAuthenticated",
    }),
    storageCookies() {
      return this.cookiesPrivacy;
    },
  },
  mounted() {
    this.checkScrollBottom();
    $("html,body").animate({
      scrollTop: 0,
    });

    if (this.$route.query.fbError) {
      $("#facebook-error").modal("show");
    }

    this.deleteLastInteractionTime();

    if (this.isSafari() && this.showSafariWarning) {
      console.log(this.$refs.safariWarning);
      this.$refs.safariWarning.show();
    }

    if (
      this.prevRoute.name === "SItemDetailFromLandingPage" ||
      this.prevRoute.name === "SSearchResultFromLandingPage"
    ) {
      this.$router.go();
    }
  },
  methods: {
    isSafari() {
      if (window.navigator.vendor !== "Google Inc.") {
        if (!window.navigator.userAgent.match("CriOS")) {
          if (navigator.userAgent.indexOf("Safari") !== -1) {
            this.showSafariWarning = true;
            return true;
          }
        }
      }

      return false;
    },
    accept(a) {
      this.cookiesPrivacy = a;
    },
    closeModal(modalId) {
      $(`#${modalId}`).modal("hide");
      this.$refs.fbError.closeModal();
    },
    deleteLastInteractionTime() {
      localStorage.removeItem("last_interaction");
    },
    activateRegistrationForm() {
      this.$refs.loginRegistrationForm.$refs.register.click();
    },
    checkScrollBottom() {
      window.onscroll = () => {
        if (window.scrollY > 300) {
          this.isBottom = true;
        } else {
          this.isBottom = false;
        }
      };
    },

    async confirmRedirect() {
      this.closeModal("login-redirect-modal");
      this.canRedirect = true;
      await this.$router
        .push(this.redirectTo)
        .then(() => {
          this.canRedirect = false;
        })
        .catch(() => {
          console.log("user not logged");
        });
    },
    saveOption(value) {
      this.dontShowModalAgain = value;
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
    });
  },
  beforeRouteLeave(to, from, next) {
    if (
      this.isUserAuthenticated ||
      this.canRedirect ||
      to.path === "/" ||
      to.name === "loginRedirect" ||
      to.name === "SItemDetailFromLandingPage"
    ) {
      next();
    } else {
      if (
        to.path !== "/login" &&
        to.name !== "SSearchResultFromLandingPage" &&
        to.path !== "/signup" &&
        to.path !== "/landing-help" &&
        to.path !== "/contact-us" &&
        to.name !== "SItemDetailFromLandingPage"
      ) {
        this.redirectTo = to.fullPath;
        $("#login-redirect-modal").modal("show");
      } else {
        next();
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.header-spacer--standard {
  height: 100px !important;
}
.lead-content {
  background-color: $light;
  width: fit-content;
}
.login-text{
  color: rgba(0, 0, 0, 0.6) !important
}
</style>

<style lang="scss">
@media screen and (min-width: 768px) {
  .safari-space .button-fixed {
    bottom: 230px;
  }
}
@media screen and (min-width: 1600px) {
  .lead-content {
    display: contents;
  }
}
</style>
